// Year heatmap utilities
(function() {
  function scrollToToday(rootEl) {
    try {
      var root = rootEl || document;
      var sc = root.querySelector ? root.querySelector('.year-heatmap-scroll') : null;
      if (!sc) return;
      var idx = parseInt(sc.dataset.todayWeekIndex || '0', 10);
      var table = sc.querySelector('table.year-heatmap-table');
      if (!table || !table.tBodies || table.tBodies.length === 0) { sc.scrollLeft = sc.scrollWidth; return; }
      var row = table.tBodies[0].rows[0];
      if (!row || !row.cells) { sc.scrollLeft = sc.scrollWidth; return; }
      var cell = row.cells[idx + 1]; // +1 for the first th.dow
      if (cell) {
        var cellRight = cell.offsetLeft + cell.offsetWidth;
        sc.scrollLeft = Math.max(0, cellRight - sc.clientWidth);
      } else {
        sc.scrollLeft = sc.scrollWidth;
      }
    } catch(e) {
      // no-op
    }
  }

  // expose
  window.scrollYearHeatmapToToday = scrollToToday;

  // initial load (HTML render)
  document.addEventListener('turbolinks:load', function() {
    if (window.Janreco.currentPath().match(/^\/point_calendars$/)) {
      window.scrollYearHeatmapToToday();
    }
  });
})();


